<template>
  <div>
    <commonHeader title="帮助文档" />
    <div class="common_contentBox">
      <commonTable ref="helpDocumentation" />
    </div>
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import commonHeader from '@/components/commonHeader';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
import { activityQueryDetails } from '@/views/activitieList/service';
import { commonServer } from '@/API/home';

export default {
  name: 'HelpDocumentation',
  data () {
    return {};
  },
  methods: {
    preview (row) {
      commonServer.getPreviewUrl(row.fileId).then(res => {
        if (res.status === '200') {
          let pdfPath = encodeURIComponent(res.data);
          let previewURL = `/static/pdf/web/viewer.html?file=${pdfPath}`;
          window.open(previewURL, '_blank');
        }
      });
    },
    approvalHandle (row) {
      // 拼接下载链接
      activityQueryDetails.getDownloadUrl(row.fileId).then(res => {
        if (res.status === '200') {
          let downloadUrl = '';
          downloadUrl = res.data;
          // 开始下载
          if (downloadUrl) {
            this.download(downloadUrl, row.fileName);
          } else {
          }
        }
      });
    },
    getBlob (url, cb) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onload = function () {
        if (xhr.status === 200) {
          cb(xhr.response);
        }
      };
      xhr.send();
    },
    saveAs (blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement('a');
        var body = document.querySelector('body');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        // fix Firefox
        link.style.display = 'none';
        body.appendChild(link);
        link.click();
        body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      }
    },
    download (url, filename) {
      // 防止this引用出错，使用中间变量
      let _that = this;
      _that.getBlob(url, function (blob) {
        _that.saveAs(blob, filename);
      });
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('file.DocumentName'))
          ._width('50%')
          ._data('fileName')
        // ._cellType('customDom')
        // ._cellData({
        //   formater: ({ row, column }) => {
        //     return (
        //       <div>
        //         <el-button type="text" onClick={() => { this.approvalHandle(row); }}>{ row.fileName }</el-button>
        //       </div>
        //     );
        //   }
        // })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('file.UploadTime'))
          ._width('12%')
          ._data('createTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = new Date(row[column.property].replace(/-/g, '/')).format('yyyy-MM-dd');
              return (
                <span>{ date }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('general.Uploader'))
          ._width('12%')
          ._data('createUserName')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('general.Operation'))
          ._width('180')
          ._fixed('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => {
                    this.approvalHandle(row);
                  }}>{this.$t('general.Download')}
                  </el-button>
                  <el-button type="text" onClick={() => {
                    this.preview(row);
                  }}>{this.$t('general.Preview')}
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.helpDocumentation.setColumn(column, { page: false });
      this.$refs.helpDocumentation.loadTable({ url: '/file/list/HelpDoc', method: 'get' });
    }
  },
  components: {
    commonTable,
    commonHeader
  },
  mounted () {
    this.loadTable();
  }

};
</script>

<style scoped>

</style>
